import ArrowRightSvg from "../../assets/images/Arrow_Right.svg";
import "./ArrowRight.scss";

export default function ArrowRight(props) {
  return <img className="arrowRight" alt="" src={ArrowRightSvg} />;
}
